import { SID_AG_BASE_URL } from 'Modules/shareholders-id/constants';

export default {
  controller: [function () {}],
  templateUrl: `${SID_AG_BASE_URL}/views/sid-request-details/results/sid-request-details-results.template.html`,
};
